// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { ElementType, ReactNode } from "react";
import { useMemo } from "react";
import { useSetPageTitle } from "@/components/layout/page-title-context";

interface Breadcrumb {
  label: string;
  to: string;
}

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  breadcrumbs?: Breadcrumb[];
  icon?: ElementType;
}

export function PageHeader({ title, description, subtitle, actions, breadcrumbs, icon }: PageHeaderProps) {
  const stableBreadcrumbs = useMemo(() => breadcrumbs, [breadcrumbs]);
  useSetPageTitle(title, description, stableBreadcrumbs, icon);

  if (!actions && !subtitle) return null;

  return (
    <>
      {subtitle && <div className="flex items-center gap-2 px-4 py-2 border-b">{subtitle}</div>}
      {actions && <div className="flex items-center justify-end gap-2 px-6 pt-4">{actions}</div>}
    </>
  );
}
